import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { requestStoryAns } from '~/redux/storyData'
import { EllipsisReduxStore } from '~/types'

export default function useStory() {
  const dispatch = useDispatch()
  const story = useSelector(
    (state: EllipsisReduxStore) => state.storyData.story
  )

  React.useEffect(() => {
    dispatch(requestStoryAns())
  }, [dispatch])

  return story
}
